<template>
	<div id="queue-controller">
		<span>{{ $t("song.queue.title") }}</span>
		<button type="button" @click="addSongToQueue" v-if="!isCurrentSongInQueue" class="queue-add">{{ $t("song.queue.add") }}</button>
		<button type="button" @click="playedSongFromQueue" v-if="isCurrentSongInQueue" class="queue-played">{{ $t("song.queue.done") }}</button>
		<button type="button" @click="removeSongFromQueue" v-if="isCurrentSongInQueue" class="queue-cancelled">{{ $t("song.queue.cancel") }}</button>
	</div>
</template>

<script>
	import { SongService } from "@/services/SongService";
	import { mapState } from "vuex";

	export default {
		computed: {
			...mapState([ "queueSongs", "currentSong", "songsFilter" ]),
			isCurrentSongInQueue() {
				return this.queueSongs.includes(this.currentSong.songId);
			},
		},
		methods: {
			addSongToQueue() {
				SongService.addSongToQueue(this.currentSong);
				this.$notify({
					type: "success",
					text: this.$t("notification.songAddedToQueue"),
				});
			},
			playedSongFromQueue() {
				if (this.songsFilter.onlyQueue) document.dispatchEvent(new Event("PrepareRouteToNextSong"));
				SongService.playedSongFromQueue(this.currentSong);
				if (this.songsFilter.onlyQueue) document.dispatchEvent(new Event("RouteToNextSong"));
				this.$notify({
					type: "success",
					text: this.$t("notification.songPlayedFromQueue"),
				});
			},
			removeSongFromQueue() {
				if (this.songsFilter.onlyQueue) document.dispatchEvent(new Event("PrepareRouteToNextSong"));
				SongService.removeSongFromQueue(this.currentSong);
				this.$notify({
					type: "success",
					text: this.$t("notification.songRemovedFromQueue"),
				});
				if (this.songsFilter.onlyQueue) document.dispatchEvent(new Event("RouteToNextSong"));
			}
		}
	}
</script>

<style lang="scss" scoped>
	#queue-controller {
		position: relative;
		margin: 5px 0 0 10px;
		float: left;
		width: 235px;
		height: 40px;
		background-color: rgb(37, 142, 123);
		border-radius: 4px;

		span {
			display: block;
			margin: 11px 13px;
			color: rgba(255, 255, 255, 0.8);
			float: left;
		}

		button {
			float: left;
			font-weight: 300;
			margin: 5px 0;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 30px;

			cursor: pointer;
			border-radius: 4px;

			&:focus {
				outline: none;
			}

			&.queue-add {
				padding: 0 20px;
				background-color: #ef904e;
				color: rgba(255, 255, 255, 0.75);

				&:hover {
					background-color: #d07a46;
				}
			}

			&.queue-played {
				padding: 0 12px;
				margin-right: 10px;
				background-color: #88498F;
				color: rgba(255, 255, 255, 0.75);

				&:hover {
					background-color: #69376f;
				}
			}

			&.queue-cancelled {
				padding: 0 12px;
				background-color: #a4a4a4;
				color: rgba(255, 255, 255, 0.75);

				&:hover {
					background-color: #838383;
				}
			}
		}

		@media only screen and (max-width: 740px) {
			width: 166px;
			span {
				display: none;
			}

			button {
				&.queue-add {
					margin-left: 8px;
				}

				&.queue-played {
					margin-left: 8px;
				}
			}
		}

	}
</style>
